export default __webpack_public_path__ + "static/media/Rectangle 2801.4990cdd7.svg";